/**
 * @flow
 * @relayHash e0c691a2c5cd2e8eba293426266d51a2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShipmentUpsRatesQueryVariables = {|
  shipmentId: string
|};
export type ShipmentUpsRatesQueryResponse = {|
  +upsRates: $ReadOnlyArray<{|
    +serviceCode: string,
    +serviceName: string,
    +totalCharge: number,
    +currency: string,
    +estimatedDays: ?number,
  |}>
|};
export type ShipmentUpsRatesQuery = {|
  variables: ShipmentUpsRatesQueryVariables,
  response: ShipmentUpsRatesQueryResponse,
|};
*/


/*
query ShipmentUpsRatesQuery(
  $shipmentId: ID!
) {
  upsRates(shipmentId: $shipmentId) {
    serviceCode
    serviceName
    totalCharge
    currency
    estimatedDays
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "shipmentId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "upsRates",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "shipmentId",
        "variableName": "shipmentId"
      }
    ],
    "concreteType": "UPSRate",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceCode",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCharge",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "estimatedDays",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ShipmentUpsRatesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ShipmentUpsRatesQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ShipmentUpsRatesQuery",
    "id": null,
    "text": "query ShipmentUpsRatesQuery(\n  $shipmentId: ID!\n) {\n  upsRates(shipmentId: $shipmentId) {\n    serviceCode\n    serviceName\n    totalCharge\n    currency\n    estimatedDays\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd9a5e5e144fdd00070835be9170d8d0e';
module.exports = node;
